import { render } from "./Charge.vue?vue&type=template&id=bd66e81a&ts=true"
import script from "./Charge.vue?vue&type=script&lang=ts"
export * from "./Charge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__